import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

const linkify = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);

  return parts.map((part, i) =>
    urlRegex.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "blue" }}
      >
        {part}
      </a>
    ) : (
      part
    )
  );
};

export const BuyAmazon = ({ data }) => {
  if (!data || !Array.isArray(data)) return null;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <div id="exemption">
      <Helmet>
        <title>ABX Shipping - Exención de impuestos Amazon</title>
      </Helmet>
      <div className="container">
        <div className="row text-center">
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>EXENCIÓN DE IMPUESTOS</h2>
          </div>
        </div>
        <Slider {...settings}>
          {data.map((item, index) => (
            <div key={index}>
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h4 style={{ fontSize: "24px" }}>{item.titulo}</h4>
                <p style={{ fontSize: "16px" }}>{linkify(item.descripcion)}</p>
                {item.archivo && (
                  <a
                    href={item.archivo}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "blue",
                      display: "block",
                      marginTop: "10px",
                    }}
                    download
                  >
                    Descargar archivo de exención
                  </a>
                )}
              </div>
              <img
                src={`/img/amazon/paso${index + 1}.jpg`}
                alt={`Paso ${index + 1}`}
                style={{ width: "100%", height: "55%" }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
